import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'

interface ConfigStore {
  config: Settings
  setConfig: (config: Settings) => void
}

export const useConfigStore = create<ConfigStore>()(
  persist(
    (set) => ({
      config: {
        apiKey: '',
        orgId: '',
      },
      setConfig: (config) => set({ config }),
    }),
    {
      name: 'raster-config',
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
)
